module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', _vm._l((_vm.valueArray), function(tag, i) {
    return _c('span', {
      staticClass: "badge badge-primary tag"
    }, [_vm._v("\n\t\t" + _vm._s(_vm.categories[tag] ? _vm.categories[tag].name : _vm.$t('status.error')) + "\n\t")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ddf5030!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/base/category/c-categories.vue
// module id = 638
// module chunks = 1